<template>
  <div v-if="upcomingEvent" class="custom-event-banner" @click="redirectToEvent">
    <img
        :alt="upcomingEvent.name"
        class="event-card-custom"
        :src="resolvePublicUrl(upcomingEvent.proxima_Image)"
    />
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useUpcomingEvent } from "../../composables/subscription";
import pbDomain from "../../utils/pbDomain";
import {resolvePublicUrl} from "../../utils/fileUrl";

const { upcomingEvent, getUpcomingEvent } = useUpcomingEvent();

const formatEventLink = (eventData) => {
  const id = eventData.id;
  const name = eventData.name;

  const slug = name
      .replaceAll("Critical Materials Forum - ", "")
      .replaceAll(" ", "-")
      .replaceAll("%", "percent")
      .replaceAll("/", "-")
      .toLowerCase();

  return `${pbDomain}/events/${id}/${slug}`;
};

const redirectToEvent = () => {
  if (!upcomingEvent.value) return;
  window.location.href = formatEventLink(upcomingEvent.value);
};

onMounted(() => {
  getUpcomingEvent();
});
</script>

<style scoped>
.custom-event-banner {
  justify-self: center;
  padding: 0;
  cursor: pointer;
}

.event-card-custom {
  backdrop-filter: blur(12px);
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: 350px;
  max-width: 200px;
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);
    border-color: rgba(255, 255, 255, 0.3);
  }
}
</style>